import api from './interceptor'; // axios avec interceptors (token, etc)
import * as config from './../config/config';

// --------------------------------------------------
// GET liste des articles
// --------------------------------------------------
export async function getArticles() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_ARTICLES);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// --------------------------------------------------
// GET article par ID
// --------------------------------------------------
export async function getArticleById(article_id) {
    try {
        const response = await api.get(`${config.REACT_APP_ENDPOINT_GET_ARTICLE}/${article_id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// --------------------------------------------------
// CREATE article
// --------------------------------------------------
export async function createArticle(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_ARTICLE, {
            nom: data.nom,
            description: data.description,
            categorie_id: data.categorie_id,
            etat_id: data.etat_id,
            emplacement_id: data.emplacement_id,
            // quantite: data.quantite || 0
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// --------------------------------------------------
// UPDATE article
// --------------------------------------------------
export async function updateArticle(data) {
    try {
        const response = await api.put(`${config.REACT_APP_ENDPOINT_UPDATE_ARTICLE}/${data.id}`, {
            code: data.code,
            nom: data.nom,
            description: data.description,
            categorie_id: data.categorie_id,
            etat_id: data.etat_id,
            emplacement_id: data.emplacement_id
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// --------------------------------------------------
// DELETE article
// --------------------------------------------------
export async function deleteArticle(article_id) {
    try {
        const response = await api.delete(`${config.REACT_APP_ENDPOINT_DELETE_ARTICLE}/${article_id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        return { status: "error", description: error.message };
    }
}

export async function getEtats() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_ETATS);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function createEtat(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_ETAT, {
            libelle: data.libelle
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateEtat(data) {
    try {
        const response = await api.put(`${config.REACT_APP_ENDPOINT_UPDATE_ETAT}/${data.id}`, {
            libelle: data.libelle
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteEtat(id) {
    try {
        const response = await api.delete(`${config.REACT_APP_ENDPOINT_DELETE_ETAT}/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        return { status: "error", description: error.message };
    }
}


export async function getCategories() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_CATEGORIES);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function createCategorie(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_CATEGORIE, {
            nom: data.nom,
            description: data.description
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateCategorie(data) {
    try {
        const response = await api.put(`${config.REACT_APP_ENDPOINT_UPDATE_CATEGORIE}/${data.id}`, {
            nom: data.nom,
            description: data.description
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteCategorie(id) {
    try {
        const response = await api.delete(`${config.REACT_APP_ENDPOINT_DELETE_CATEGORIE}/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        return { status: "error", description: error.message };
    }
}


export async function getEmplacement() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_EMPLACEMENTS);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function createEmplacement(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_EMPLACEMENT, {
            nom: data.nom,
            description: data.description
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateEmplacement(data) {
    try {
        const response = await api.put(`${config.REACT_APP_ENDPOINT_UPDATE_EMPLACEMENT}/${data.id}`, {
            nom: data.nom,
            description: data.description
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// MOUVEMENT
export async function createMouvement(data) {
    try {
        const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_MOUVEMENT, data);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getMouvementsStock() {
    try {
        const response = await api.get(config.REACT_APP_ENDPOINT_LIST_MOUVEMENTS);
        return response.data;
    } catch (error) {
        throw error;
    }
}